import React from "react";
import { userprofile } from "../../Model/Users"; //Include Home
import {
  Link
} from "react-router-dom";

import { isMobile } from "react-device-detect";
import { withRouter, VirsionCheck } from "../../Helpers/Common"; //Include Home
import { SVGIcons, ImgIcons } from "../../Helpers/Common";
import { Helmet, HelmetProvider } from "react-helmet";
import { motion } from "framer-motion";
import { Mobilemenu } from "../Mobile_menu/Mobilemenu";
import Profilemenu from "../Profile_menu/Profilemenu";
import BarLoader from "react-spinners/BarLoader";
import Manageprofiledesk from "../../components/Manageprofiledesk/Manageprofiledesk"
// import { Profilemenudesk } from "../../components/Profilemenudesk/Profilemenudesk"

var SVGIcon = "";
var ImageData = "";
var name = "";
SVGIcons().then((resultData) => (SVGIcon = resultData));
ImgIcons().then((result) => (ImageData = result));

class Manageprofile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      VirsionCheckData: [],
      VirsionCheckDataloaded: false,
      DataisLoaded: false,
      ProfileData: false,
      isLive:true
    };
  }

  componentDidMount() {
    //Get Virsion Check Data
    VirsionCheck().then((vcheckres) => {
      this.setState({
        isLive: JSON.parse(vcheckres.data).data.is_live_tv
      });
      let data = {
        seesionID:localStorage.getItem("session_id"),
        userID:localStorage.getItem("userID")
      }
      userprofile(data).then((userprofile) => {
        if (userprofile.data.success == false) {
          this.props.navigate("/createaccount");
        } else {
          let userData = JSON.parse(userprofile.data.message)
          this.setState({
            VirsionCheckData: vcheckres,
            VirsionCheckDataloaded: true,
            DataisLoaded: true,
            ProfileData: userData.user_data,
          });
        }
      });
    });
  }

  /*-------Logout-------*/
  backbtn() {
    this.props.navigate("/profile");
  }

  render() {
    if (this.state.VirsionCheckDataloaded == false) {
      // return <div className="loader"></div>;
      return <div className="loader"><BarLoader color="#ff000f" /></div>;
    } else {
      var MetaData = JSON.parse(this.state.VirsionCheckData.data).data.page
        .signup;
      var UserprofileData = this.state.ProfileData;
      if (UserprofileData.errorcode == "1008") {
        this.props.navigate("/createaccount");
      }
      return (
        <>
          <motion.div
            className=""
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 1 }}
            key="1"
          >
            <header>
              <div className="mainNav pmenu dD-none">
                <div className="docubayBack white">
                  <img
                    src={SVGIcon["back.svg"]}
                    alt="DocuBay"
                    onClick={() => {
                      this.backbtn();
                    }}
                  />{" "}
                  Manage Profile
                </div>
              </div>
            </header>
            <main>
              <section className="mb-0 dD-none">
                <div className="temp60">
                  <div className="temp60-inn">
                    <img
                      src={ImageData["profile.png"]}
                      alt="DocuBay"
                      className="w-100 manageprofile-tab-img"
                    />
                    <div className="temp60-area">
                      <div className="temp60-profPic">
                        <img
                          src={SVGIcon["mask.svg"]}
                          alt="Profile Pic"
                          className="temp60-profImg"
                        />
                      </div>
                      <h5>{name}</h5>
                      <h6>{UserprofileData.name}</h6>
                      <h6>{UserprofileData.country_code} {UserprofileData.mobile_number}</h6>
                      <h6>{UserprofileData.user_email}</h6>
                    </div>
                  </div>
                </div>
              </section>
              <section className="mb-0 dD-none">
                <div className="temp46">
                  <div className="temp46-inn temp60-mt-0">
                    {UserprofileData.name == "" && (
                      <div className="temp46-area">
                        <Link to="/add-name">
                          <div className="img-area">
                            <img src={SVGIcon["add-name.svg"]} alt="DocuBay" />
                          </div>
                          Add Name
                        </Link>
                      </div>
                    )}
                    {UserprofileData.name != "" && (
                      <div className="temp46-area">
                        <Link to="/change-name">
                          <div className="img-area">
                            <img src={SVGIcon["add-name.svg"]} alt="DocuBay" />
                          </div>
                          Add Name
                        </Link>
                      </div>
                    )}
                    {UserprofileData.user_email == "" && (
                      <div className="temp46-area">
                        <Link to="/add-email">
                          <div className="img-area">
                            <img src={SVGIcon["email.svg"]} alt="DocuBay" />
                          </div>
                          Add Email Address
                          <div className="action-need"><img src={SVGIcon['alert.png']} /> <h4>Action Needed</h4></div>
                        </Link>

                      </div>
                    )}
                    {UserprofileData.user_email != "" && (
                      <div className="temp46-area">
                        <Link to="/change-email">
                          <div className="img-area">
                            <img src={SVGIcon["email.svg"]} alt="DocuBay" />
                          </div>
                          Change Email Address
                        </Link>
                      </div>
                    )}
                    {UserprofileData.is_verified_email == "" && UserprofileData.user_email != "" && (
                      <div className="temp46-area">
                        <Link to="/verify-email">
                          <div className="img-area">
                            <img src={SVGIcon["email.svg"]} alt="DocuBay" />
                          </div>
                          Verify Email Address
                        </Link>
                      </div>
                    )}
                    {/* {UserprofileData.user_data.user_mobile == "" && (
                      <div className="temp46-area">
                        <Link to="/add-mobile">
                          <div className="img-area">
                            <img src={SVGIcon["email.svg"]} alt="DocuBay" />
                          </div>
                          Add Mobile Number
                          <div className="action-need"><img src={SVGIcon['alert.png']} /> Action Needed</div>
                        </Link>

                      </div>
                    )}*/}
                    {UserprofileData.user_mobile != "" && (
                      <div className="temp46-area">
                        <Link to="/change-mobile">
                          <div className="img-area">
                            <img src={SVGIcon["phone.svg"]} alt="DocuBay" />
                          </div>
                          Change Phone Number
                        </Link>
                      </div>
                    )}

                    {UserprofileData.is_verified_mobile == "" && UserprofileData.user_mobile != "" && (
                      <div className="temp46-area">
                        <Link to="/verify-mobile">
                          <div className="img-area">
                            <img src={SVGIcon["phone.svg"]} alt="DocuBay" />
                          </div>
                          Verify Phone Number
                        </Link>
                      </div>
                    )}

                    {UserprofileData.user_mobile == "" && (
                      <div className="temp46-area">
                        <Link to="/add-mobile">
                          <div className="img-area">
                            <img src={SVGIcon["phone.svg"]} alt="DocuBay" />
                          </div>
                          Add Phone Number
                          <div className="action-need"><img src={SVGIcon['alert.png']} /> <h4>Action Needed</h4></div>
                        </Link>
                      </div>
                    )}

                    <div className="temp46-area">
                      <Link to="/change-password">
                        <div className="img-area">
                          <img
                            src={SVGIcon["generate-pin.svg"]}
                            alt="DocuBay"
                          />
                        </div>
                        Change Password
                      </Link>
                    </div>
                    {/*<div className="temp46-area">
                      <a href="billing-details.html">
                        <div className="img-area">
                          <img src={SVGIcon["bill.svg"]} alt="DocuBay" />
                        </div>
                        Billing Details
                      </a>
                    </div>*/}
                    <div className="temp46-area">
                      <Link to="/manage-devices">
                        <div className="img-area">
                          <img src={SVGIcon["device.svg"]} alt="DocuBay" />
                        </div>
                        Manage Devices
                      </Link>
                    </div>
                  </div>
                </div>
              </section>
              <Manageprofiledesk versioncheck={this.state.VirsionCheckData} profile={this.state.ProfileData} />
            </main>
            {/* <Mobilemenu active="5" /> */}
            {isMobile ? <Mobilemenu active="5" isLive={this.state.isLive}/> : <Profilemenu versioncheck={this.state.VirsionCheckData} profile={UserprofileData} />}
            {/* {isMobile ? <Mobilemenu active="5" /> : <Profilemenudesk userdata={this.state.userData} />} */}
          </motion.div>
        </>
      );
    }
  }
}
export default withRouter(Manageprofile);
